import { Subject } from "rxjs";

/** Emit to open the impersonation dialog (true) or close it (false). */
export const showImpersonateDialog = new Subject<boolean>();

/** Convenience opener. Kept here (not the .tsx) so ImpersonateUserDialog exports
 *  only its component — a React Fast Refresh requirement. */
export function openImpersonateDialog(): void {
  showImpersonateDialog.next(true);
}
